import type { GetStaticPaths, GetStaticProps } from "next";
import { useRouter } from "next/router";

import Loading from "lib/components/CenterLoading";
import type { LandingProps } from "lib/components/landings/Landing";
import Landing from "lib/components/landings/Landing";
import Page404 from "pages/404";

const Content = (attrbts: LandingProps) => {
  const router = useRouter();

  // Display loading until `getStaticProps()` finishes running, and populates the props.
  if (router.isFallback) {
    return <Loading />;
  }

  // If attributes are not populated, return an empty object.
  if ("error" in attrbts) {
    return <Page404 />;
  }

  return <Landing {...attrbts} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/items/landings/`
    );
    const posts = await res.json();

    const paths = posts.data.map((post: { page_slug: string }) => {
      return { params: { slug: post.page_slug } };
    });

    return {
      paths,
      fallback: true,
    };
  } catch {
    // If fetch fails during build (e.g., in Docker), return empty paths
    // Pages will be generated on-demand due to fallback: true
    return {
      paths: [],
      fallback: true,
    };
  }
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/items/landings?filter[page_slug][_eq]=${params?.slug}`
    );
    const post = await res.json();

    if (post.data && post.data.length === 1) {
      return {
        props: post.data[0],
        revalidate: 10,
      };
    }
    return {
      props: { error: "Post not found" },
      revalidate: 10,
    };
  } catch {
    // If fetch fails, return error props
    return {
      props: { error: "Failed to fetch" },
      revalidate: 10,
    };
  }
};

export default Content;
